// 快手短视频平台 - 统一演示数据
// 说明：本文件为纯静态演示数据，列表与详情页共享同一份数据源，保证内容一致。

export interface CategoryItem {
  id: string;
  name: string;
  icon: string;
  desc: string;
  cover: string;
  gradient: string;
}

export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  categoryId: string;
  categoryName: string;
  authorId: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  views: number;
  duration: string;
  likes: number;
  comments: number;
  tags: string[];
  description: string;
}

export interface AuthorItem {
  id: string;
  name: string;
  avatar: string;
  bio: string;
  followers: number;
}

export const categories: CategoryItem[] = [
  {
    id: "life",
    name: "生活",
    icon: "ri-home-heart-line",
    desc: "记录日常点滴，分享真实的生活方式与温暖瞬间。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20cozy%20modern%20living%20room%20with%20plants%20and%20warm%20sunlight%20through%20large%20windows%2C%20clean%20minimal%20lifestyle%20scene%2C%20soft%20neutral%20tones%2C%20editorial%20interior%20photography%20with%20harmonious%20composition&width=800&height=600&seq=ks-cat-life&orientation=landscape",
    gradient: "from-primary-100 to-primary-200",
  },
  {
    id: "food",
    name: "美食",
    icon: "ri-restaurant-2-line",
    desc: "家常菜、探店、烘焙，带你发现每一口好味道。",
    cover:
      "https://readdy.ai/api/search-image?query=Appetizing%20hot%20bowl%20of%20noodles%20with%20fresh%20vegetables%20on%20a%20rustic%20wooden%20table%2C%20warm%20golden%20light%2C%20clean%20simple%20background%2C%20professional%20food%20photography%20with%20rich%20vibrant%20colors&width=800&height=600&seq=ks-cat-food&orientation=landscape",
    gradient: "from-accent-100 to-accent-200",
  },
  {
    id: "entertainment",
    name: "娱乐",
    icon: "ri-movie-2-line",
    desc: "搞笑名场面、影视解说、综艺花絮，快乐停不下来。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20vintage%20cinema%20interior%20with%20glowing%20screen%20light%20and%20red%20seats%2C%20dramatic%20atmosphere%2C%20soft%20focus%20background%2C%20cinematic%20entertainment%20scene%20with%20elegant%20composition&width=800&height=600&seq=ks-cat-ent&orientation=landscape",
    gradient: "from-secondary-100 to-secondary-200",
  },
  {
    id: "funny",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    desc: "沙雕日常、萌宠翻车，笑点密集治愈一整天。",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20golden%20retriever%20puppy%20with%20a%20red%20ball%20on%20green%20grass%20in%20a%20sunny%20backyard%2C%20joyful%20cheerful%20mood%2C%20soft%20natural%20light%2C%20blurred%20garden%20background%20with%20warm%20tones&width=800&height=600&seq=ks-cat-funny&orientation=landscape",
    gradient: "from-primary-100 to-accent-100",
  },
  {
    id: "education",
    name: "教育",
    icon: "ri-book-open-line",
    desc: "知识科普、技能学习、考试干货，学得轻松又高效。",
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20study%20desk%20with%20open%20notebook%2C%20laptop%20and%20coffee%20cup%2C%20soft%20natural%20window%20light%2C%20tidy%20modern%20room%20background%2C%20focused%20learning%20mood%20with%20clean%20minimal%20warm%20tones&width=800&height=600&seq=ks-cat-edu&orientation=landscape",
    gradient: "from-accent-100 to-secondary-100",
  },
  {
    id: "dance",
    name: "舞蹈",
    icon: "ri-music-2-line",
    desc: "街舞、民族舞、手势舞，跟着节拍一起动起来。",
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20young%20dancers%20performing%20street%20dance%20in%20an%20urban%20plaza%2C%20dynamic%20motion%2C%20colorful%20graffiti%20wall%20background%2C%20bright%20daylight%2C%20cinematic%20vibrant%20style%20full%20of%20joyful%20movement&width=800&height=600&seq=ks-cat-dance&orientation=landscape",
    gradient: "from-primary-100 to-secondary-100",
  },
  {
    id: "music",
    name: "音乐",
    icon: "ri-mic-line",
    desc: "翻唱、原创、乐器演奏，用声音传递情绪。",
    cover:
      "https://readdy.ai/api/search-image?query=Acoustic%20guitar%20resting%20against%20a%20sunlit%20window%20with%20green%20plants%2C%20warm%20afternoon%20light%2C%20cozy%20music%20room%20background%2C%20calm%20inspiring%20mood%2C%20soft%20focus%20with%20cinematic%20warm%20tones&width=800&height=600&seq=ks-cat-music&orientation=landscape",
    gradient: "from-accent-100 to-primary-100",
  },
  {
    id: "travel",
    name: "旅行",
    icon: "ri-plane-line",
    desc: "山野海岛、城市漫游，把远方装进镜头里。",
    cover:
      "https://readdy.ai/api/search-image?query=Hiker%20standing%20on%20a%20rocky%20mountain%20ridge%20overlooking%20a%20misty%20green%20valley%20at%20golden%20hour%2C%20dramatic%20clouds%2C%20epic%20travel%20adventure%20scene%2C%20cinematic%20wide%20shot%20with%20warm%20sky%20tones&width=800&height=600&seq=ks-cat-travel&orientation=landscape",
    gradient: "from-secondary-100 to-accent-100",
  },
];

export const authors: AuthorItem[] = [
  {
    id: "a1",
    name: "阿May的生活",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20young%20asian%20woman%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20pastel%20background%2C%20casual%20modern%20style%2C%20clean%20high%20detail%20profile%20photo&width=120&height=120&seq=ks-av-01&orientation=squarish",
    bio: "记录平凡日子里的小确幸，生活方式博主。",
    followers: 128400,
  },
  {
    id: "a2",
    name: "味觉实验室",
    avatar:
      "https://readdy.ai/api/search-image?query=Cheerful%20asian%20male%20chef%20smiling%20portrait%20wearing%20white%20apron%2C%20soft%20studio%20light%2C%20plain%20warm%20neutral%20background%2C%20friendly%20cooking%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-02&orientation=squarish",
    bio: "把餐厅的味道搬进厨房，家常菜也能很讲究。",
    followers: 89200,
  },
  {
    id: "a3",
    name: "大魔王搞笑社",
    avatar:
      "https://readdy.ai/api/search-image?query=Humorous%20young%20asian%20man%20with%20playful%20grin%20portrait%2C%20bright%20studio%20light%2C%20plain%20colorful%20pastel%20background%2C%20fun%20cheerful%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-03&orientation=squarish",
    bio: "专业制造笑点十年，专治不开心。",
    followers: 210300,
  },
  {
    id: "a4",
    name: "舞动青春",
    avatar:
      "https://readdy.ai/api/search-image?query=Confident%20young%20asian%20female%20dancer%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20pastel%20background%2C%20energetic%20modern%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-04&orientation=squarish",
    bio: "舞蹈工作室主理人，用身体讲故事。",
    followers: 156800,
  },
  {
    id: "a5",
    name: "知识小宇宙",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20asian%20male%20teacher%20with%20glasses%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20calm%20neutral%20background%2C%20intellectual%20clean%20profile%20photo&width=120&height=120&seq=ks-av-05&orientation=squarish",
    bio: "三分钟一个知识点，让科普变得有趣。",
    followers: 74200,
  },
  {
    id: "a6",
    name: "山海旅行记",
    avatar:
      "https://readdy.ai/api/search-image?query=Adventurous%20asian%20traveler%20smiling%20portrait%20wearing%20outdoor%20jacket%2C%20soft%20natural%20light%2C%20plain%20warm%20beige%20background%2C%20clean%20modern%20profile%20photo&width=120&height=120&seq=ks-av-06&orientation=squarish",
    bio: "在路上，把远方装进镜头里。",
    followers: 98300,
  },
  {
    id: "a7",
    name: "吉他阿Ken",
    avatar:
      "https://readdy.ai/api/search-image?query=Relaxed%20young%20asian%20male%20musician%20smiling%20portrait%20with%20guitar%20nearby%2C%20warm%20soft%20light%2C%20plain%20cozy%20background%2C%20clean%20artistic%20profile%20photo&width=120&height=120&seq=ks-av-07&orientation=squarish",
    bio: "写歌、弹唱，把心事唱给你听。",
    followers: 61500,
  },
  {
    id: "a8",
    name: "深夜食堂日记",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20asian%20woman%20food%20blogger%20smiling%20portrait%2C%20soft%20evening%20light%2C%20plain%20warm%20amber%20background%2C%20cozy%20clean%20profile%20photo&width=120&height=120&seq=ks-av-08&orientation=squarish",
    bio: "深夜放毒，用食物治愈每个夜晚。",
    followers: 137600,
  },
  {
    id: "a9",
    name: "萌宠放映厅",
    avatar:
      "https://readdy.ai/api/search-image?query=Young%20asian%20person%20holding%20a%20fluffy%20cat%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20cream%20background%2C%20cute%20clean%20profile%20photo&width=120&height=120&seq=ks-av-09&orientation=squarish",
    bio: "猫猫狗狗的快乐制造机，一天一条治愈你。",
    followers: 245900,
  },
  {
    id: "a10",
    name: "学霸计划本",
    avatar:
      "https://readdy.ai/api/search-image?query=Focused%20asian%20student%20smiling%20portrait%20holding%20a%20notebook%2C%20soft%20natural%20light%2C%20plain%20calm%20neutral%20background%2C%20clean%20studious%20profile%20photo&width=120&height=120&seq=ks-av-10&orientation=squarish",
    bio: "学习方法与效率工具分享，陪你一起变好。",
    followers: 52900,
  },
];

export const videos: VideoItem[] = [
  {
    id: "v1",
    title: "手把手教你做一碗地道的牛肉面",
    cover:
      "https://readdy.ai/api/search-image?query=Steaming%20bowl%20of%20hand%20pulled%20beef%20noodles%20on%20a%20rustic%20wooden%20table%2C%20warm%20golden%20light%2C%20blurred%20cozy%20kitchen%20background%2C%20close%20up%20appetizing%20food%20photography%20with%20vibrant%20rich%20colors&width=640&height=360&seq=ks-cover-01&orientation=landscape",
    categoryId: "food",
    categoryName: "美食",
    authorId: "a2",
    author: "味觉实验室",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cheerful%20asian%20male%20chef%20smiling%20portrait%20wearing%20white%20apron%2C%20soft%20studio%20light%2C%20plain%20warm%20neutral%20background%2C%20friendly%20cooking%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-02&orientation=squarish",
    publishDate: "2026-09-28",
    views: 1285000,
    duration: "08:24",
    likes: 96300,
    comments: 2410,
    tags: ["家常菜", "面食", "教程"],
    description:
      "汤要浓、面要筋、牛肉要炖得软糯。本期从熬汤底开始，一步步带你做出比外卖还香的地道牛肉面。配料表和时间节点都写在视频里，新手也能零失败，最后别忘了撒一把香菜和葱花。",
  },
  {
    id: "v2",
    title: "清晨六点的天台拉伸，开启元气一天",
    cover:
      "https://readdy.ai/api/search-image?query=Young%20woman%20stretching%20her%20arms%20on%20a%20quiet%20rooftop%20at%20sunrise%2C%20soft%20warm%20morning%20light%2C%20modern%20city%20skyline%20blurred%20behind%2C%20healthy%20calm%20lifestyle%20cinematic%20tones&width=640&height=360&seq=ks-cover-02&orientation=landscape",
    categoryId: "life",
    categoryName: "生活",
    authorId: "a1",
    author: "阿May的生活",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Friendly%20young%20asian%20woman%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20pastel%20background%2C%20casual%20modern%20style%2C%20clean%20high%20detail%20profile%20photo&width=120&height=120&seq=ks-av-01&orientation=squarish",
    publishDate: "2026-10-02",
    views: 876000,
    duration: "05:12",
    likes: 62400,
    comments: 1580,
    tags: ["生活方式", "拉伸", "早起"],
    description:
      "早起不难，难的是起来之后做点什么。分享我坚持了一年的天台拉伸流程，从颈部放松到全身唤醒只要十分钟，做完真的会开心一整天。把你的早晨仪式也留在评论区吧。",
  },
  {
    id: "v3",
    title: "办公室爆笑名场面合集",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20comedy%20club%20stage%20with%20warm%20spotlights%20and%20a%20microphone%20stand%2C%20deep%20red%20curtain%20blurred%20background%2C%20energetic%20vibrant%20cinematic%20entertainment%20scene%20with%20clean%20composition&width=640&height=360&seq=ks-cover-03&orientation=landscape",
    categoryId: "entertainment",
    categoryName: "娱乐",
    authorId: "a3",
    author: "大魔王搞笑社",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Humorous%20young%20asian%20man%20with%20playful%20grin%20portrait%2C%20bright%20studio%20light%2C%20plain%20colorful%20pastel%20background%2C%20fun%20cheerful%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-03&orientation=squarish",
    publishDate: "2026-09-30",
    views: 2340000,
    duration: "06:48",
    likes: 187600,
    comments: 4230,
    tags: ["搞笑", "职场", "合集"],
    description:
      "打工人的快乐源泉来了。收集了这周最离谱的办公室名场面，从抢会议室到团建翻车，全程无尿点。友情提示：喝水的时候千万别看，容易笑喷。",
  },
  {
    id: "v4",
    title: "街头齐舞挑战，燃爆整个广场",
    cover:
      "https://readdy.ai/api/search-image?query=Group%20of%20young%20dancers%20performing%20energetic%20street%20dance%20in%20an%20urban%20plaza%2C%20dynamic%20motion%2C%20colorful%20graffiti%20wall%20background%2C%20bright%20daylight%2C%20cinematic%20vibrant%20joyful%20style&width=640&height=360&seq=ks-cover-04&orientation=landscape",
    categoryId: "dance",
    categoryName: "舞蹈",
    authorId: "a4",
    author: "舞动青春",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Confident%20young%20asian%20female%20dancer%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20pastel%20background%2C%20energetic%20modern%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-04&orientation=squarish",
    publishDate: "2026-10-05",
    views: 1720000,
    duration: "04:36",
    likes: 143200,
    comments: 3120,
    tags: ["街舞", "齐舞", "挑战"],
    description:
      "二十个人一支舞，排练了整整两周。这次把高难度地板动作和齐舞走位都放进了视频，慢速分解在片尾。喜欢街舞的朋友可以跟着练起来，欢迎来广场一起炸场。",
  },
  {
    id: "v5",
    title: "三分钟搞懂牛顿三大定律",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20chemistry%20experiment%20flasks%20with%20glowing%20liquids%20on%20a%20lab%20bench%2C%20dramatic%20lighting%2C%20dark%20clean%20laboratory%20background%2C%20vivid%20vibrant%20science%20education%20mood&width=640&height=360&seq=ks-cover-05&orientation=landscape",
    categoryId: "education",
    categoryName: "教育",
    authorId: "a5",
    author: "知识小宇宙",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Friendly%20asian%20male%20teacher%20with%20glasses%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20calm%20neutral%20background%2C%20intellectual%20clean%20profile%20photo&width=120&height=120&seq=ks-av-05&orientation=squarish",
    publishDate: "2026-09-25",
    views: 654000,
    duration: "03:18",
    likes: 48300,
    comments: 1120,
    tags: ["物理", "科普", "学习"],
    description:
      "别再死记硬背了，用生活里的例子讲清楚惯性、加速度和作用力反作用力。看完你会发现物理其实很好玩，文末还有一道思考题等你解答。",
  },
  {
    id: "v6",
    title: "窗边弹唱：写给夏天的一首歌",
    cover:
      "https://readdy.ai/api/search-image?query=Acoustic%20guitar%20resting%20against%20a%20sunlit%20window%20with%20green%20plants%2C%20warm%20afternoon%20light%2C%20cozy%20music%20room%20background%2C%20calm%20inspiring%20mood%20with%20cinematic%20warm%20tones&width=640&height=360&seq=ks-cover-06&orientation=landscape",
    categoryId: "music",
    categoryName: "音乐",
    authorId: "a7",
    author: "吉他阿Ken",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Relaxed%20young%20asian%20male%20musician%20smiling%20portrait%20with%20guitar%20nearby%2C%20warm%20soft%20light%2C%20plain%20cozy%20background%2C%20clean%20artistic%20profile%20photo&width=120&height=120&seq=ks-av-07&orientation=squarish",
    publishDate: "2026-10-01",
    views: 432000,
    duration: "04:02",
    likes: 37800,
    comments: 860,
    tags: ["原创", "弹唱", "民谣"],
    description:
      "写了一整个夏天的歌，终于和大家见面了。整首曲子只用了四个和弦，适合刚学琴的朋友练习。歌词写的是那些来不及说再见的夏天，希望你会喜欢。",
  },
  {
    id: "v7",
    title: "徒步穿越云海，山顶的风景值得",
    cover:
      "https://readdy.ai/api/search-image?query=Hiker%20standing%20on%20a%20rocky%20mountain%20ridge%20overlooking%20a%20misty%20green%20valley%20at%20golden%20hour%2C%20dramatic%20clouds%2C%20epic%20travel%20adventure%20scene%20with%20warm%20sky%20tones&width=640&height=360&seq=ks-cover-07&orientation=landscape",
    categoryId: "travel",
    categoryName: "旅行",
    authorId: "a6",
    author: "山海旅行记",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Adventurous%20asian%20traveler%20smiling%20portrait%20wearing%20outdoor%20jacket%2C%20soft%20natural%20light%2C%20plain%20warm%20beige%20background%2C%20clean%20modern%20profile%20photo&width=120&height=120&seq=ks-av-06&orientation=squarish",
    publishDate: "2026-09-20",
    views: 1450000,
    duration: "10:15",
    likes: 112500,
    comments: 2760,
    tags: ["徒步", "云海", "户外"],
    description:
      "凌晨三点出发，爬了六个小时才到山顶。当云海在脚下翻涌的那一刻，所有的累都值了。视频里附上了装备清单和路线攻略，想去的小伙伴记得提前看天气。",
  },
  {
    id: "v8",
    title: "草莓奶油蛋糕，在家也能做",
    cover:
      "https://readdy.ai/api/search-image?query=Fresh%20strawberry%20cream%20cake%20on%20a%20marble%20counter%20with%20soft%20pink%20flowers%2C%20bright%20airy%20kitchen%2C%20pastel%20colors%2C%20appetizing%20dessert%20photography%20clean%20simple%20background&width=640&height=360&seq=ks-cover-08&orientation=landscape",
    categoryId: "food",
    categoryName: "美食",
    authorId: "a8",
    author: "深夜食堂日记",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20asian%20woman%20food%20blogger%20smiling%20portrait%2C%20soft%20evening%20light%2C%20plain%20warm%20amber%20background%2C%20cozy%20clean%20profile%20photo&width=120&height=120&seq=ks-av-08&orientation=squarish",
    publishDate: "2026-10-06",
    views: 987000,
    duration: "07:30",
    likes: 76400,
    comments: 1930,
    tags: ["烘焙", "甜点", "教程"],
    description:
      "戚风胚不回缩的小技巧都在这了，淡奶油打发到几分、草莓怎么摆更好看，一步步都讲清楚。做好冷藏两小时口感最佳，快做给你喜欢的人吧。",
  },
  {
    id: "v9",
    title: "金毛第一次见到草地，太可爱了",
    cover:
      "https://readdy.ai/api/search-image?query=Golden%20retriever%20puppy%20playing%20with%20a%20red%20ball%20on%20green%20grass%20in%20a%20sunny%20backyard%2C%20joyful%20playful%20mood%2C%20soft%20natural%20light%2C%20blurred%20garden%20background%20with%20warm%20tones&width=640&height=360&seq=ks-cover-09&orientation=landscape",
    categoryId: "life",
    categoryName: "生活",
    authorId: "a9",
    author: "萌宠放映厅",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Young%20asian%20person%20holding%20a%20fluffy%20cat%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20cream%20background%2C%20cute%20clean%20profile%20photo&width=120&height=120&seq=ks-av-09&orientation=squarish",
    publishDate: "2026-10-08",
    views: 3120000,
    duration: "02:44",
    likes: 268400,
    comments: 5870,
    tags: ["萌宠", "金毛", "治愈"],
    description:
      "三个月大的糯米第一次踏上草地，先是小心翼翼不敢走，后来直接快乐到起飞。看着它撒欢的样子，一整天的疲惫都没了。评论区求个名字，叫糯米是不是太普通了？",
  },
  {
    id: "v10",
    title: "戴墨镜的猫咪，气场两米八",
    cover:
      "https://readdy.ai/api/search-image?query=Funny%20cat%20wearing%20tiny%20sunglasses%20sitting%20on%20a%20sofa%2C%20playful%20humorous%20mood%2C%20bright%20living%20room%20blurred%20background%2C%20warm%20colors%2C%20cute%20expressive%20pet%20photography&width=640&height=360&seq=ks-cover-10&orientation=landscape",
    categoryId: "funny",
    categoryName: "搞笑",
    authorId: "a3",
    author: "大魔王搞笑社",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Humorous%20young%20asian%20man%20with%20playful%20grin%20portrait%2C%20bright%20studio%20light%2C%20plain%20colorful%20pastel%20background%2C%20fun%20cheerful%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-03&orientation=squarish",
    publishDate: "2026-10-04",
    views: 1890000,
    duration: "01:58",
    likes: 156200,
    comments: 3980,
    tags: ["搞笑", "猫", "沙雕"],
    description:
      "给家里的猫戴上了一副迷你墨镜，结果它瞬间从软萌小猫变成了整条街最靓的仔。全程一本正经，气场直接拉满，笑到我拿不稳手机。",
  },
  {
    id: "v11",
    title: "咖啡店里的日常 vlog 拍摄记录",
    cover:
      "https://readdy.ai/api/search-image?query=Young%20creator%20filming%20a%20vlog%20with%20a%20smartphone%20on%20a%20tripod%20in%20a%20bright%20modern%20cafe%2C%20cozy%20warm%20interior%2C%20lifestyle%20content%20vibe%20with%20soft%20daylight%20and%20clean%20composition&width=640&height=360&seq=ks-cover-11&orientation=landscape",
    categoryId: "entertainment",
    categoryName: "娱乐",
    authorId: "a1",
    author: "阿May的生活",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Friendly%20young%20asian%20woman%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20pastel%20background%2C%20casual%20modern%20style%2C%20clean%20high%20detail%20profile%20photo&width=120&height=120&seq=ks-av-01&orientation=squarish",
    publishDate: "2026-09-22",
    views: 543000,
    duration: "09:06",
    likes: 41900,
    comments: 940,
    tags: ["vlog", "拍摄", "日常"],
    description:
      "把一整天在咖啡店拍 vlog 的过程完整记录下来，包括机位怎么摆、光线怎么找、素材怎么剪。适合刚入门想拍日常的朋友参考，有问题评论区聊。",
  },
  {
    id: "v12",
    title: "有趣的化学实验，颜色会跳舞",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20ten%20second%20science%20experiment%20with%20glowing%20blue%20and%20purple%20liquids%20in%20glass%20beakers%20on%20a%20clean%20lab%20bench%2C%20dramatic%20dark%20background%2C%20vivid%20vibrant%20education%20mood&width=640&height=360&seq=ks-cover-12&orientation=landscape",
    categoryId: "education",
    categoryName: "教育",
    authorId: "a5",
    author: "知识小宇宙",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Friendly%20asian%20male%20teacher%20with%20glasses%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20calm%20neutral%20background%2C%20intellectual%20clean%20profile%20photo&width=120&height=120&seq=ks-av-05&orientation=squarish",
    publishDate: "2026-10-03",
    views: 721000,
    duration: "05:40",
    likes: 58200,
    comments: 1360,
    tags: ["化学", "实验", "科普"],
    description:
      "几个安全又好看的化学实验，适合在家和小朋友一起做（记得戴手套）。看颜色在液体里一层层扩散，比魔法还神奇，顺便讲清楚背后的原理。",
  },
  {
    id: "v13",
    title: "一支敦煌舞，美到屏住呼吸",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20dancer%20in%20a%20flowing%20red%20traditional%20dress%20spinning%20in%20a%20bright%20airy%20studio%2C%20graceful%20motion%20blur%20fabric%2C%20soft%20warm%20light%2C%20clean%20artistic%20background&width=640&height=360&seq=ks-cover-13&orientation=landscape",
    categoryId: "dance",
    categoryName: "舞蹈",
    authorId: "a4",
    author: "舞动青春",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Confident%20young%20asian%20female%20dancer%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20pastel%20background%2C%20energetic%20modern%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-04&orientation=squarish",
    publishDate: "2026-09-18",
    views: 1260000,
    duration: "05:55",
    likes: 108300,
    comments: 2340,
    tags: ["民族舞", "敦煌", "国风"],
    description:
      "准备了两个月的敦煌舞完整版终于来了。从手位、眼神到长绸的运用，都在里面。中国风的舞蹈真的太美了，希望有更多人看到它。",
  },
  {
    id: "v14",
    title: "钢琴独奏：献给夜晚的旋律",
    cover:
      "https://readdy.ai/api/search-image?query=Hands%20playing%20a%20grand%20piano%20in%20a%20warm%20elegant%20hall%2C%20soft%20golden%20stage%20light%2C%20blurred%20background%2C%20emotional%20music%20mood%20with%20cinematic%20warm%20tones&width=640&height=360&seq=ks-cover-14&orientation=landscape",
    categoryId: "music",
    categoryName: "音乐",
    authorId: "a7",
    author: "吉他阿Ken",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Relaxed%20young%20asian%20male%20musician%20smiling%20portrait%20with%20guitar%20nearby%2C%20warm%20soft%20light%2C%20plain%20cozy%20background%2C%20clean%20artistic%20profile%20photo&width=120&height=120&seq=ks-av-07&orientation=squarish",
    publishDate: "2026-10-09",
    views: 386000,
    duration: "04:48",
    likes: 33200,
    comments: 720,
    tags: ["钢琴", "纯音乐", "夜晚"],
    description:
      "深夜写下的旋律，适合一个人戴着耳机慢慢听。没有歌词，只有情绪，希望它能陪你度过每一个安静的时刻。喜欢的话记得收藏。",
  },
  {
    id: "v15",
    title: "热带海岛航拍，海水蓝得不像话",
    cover:
      "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20turquoise%20ocean%20waves%20meeting%20a%20white%20sandy%20tropical%20beach%20with%20palm%20trees%2C%20bright%20sunny%20sky%2C%20dreamy%20vacation%20travel%20scene%20with%20vibrant%20blue%20tones&width=640&height=360&seq=ks-cover-15&orientation=landscape",
    categoryId: "travel",
    categoryName: "旅行",
    authorId: "a6",
    author: "山海旅行记",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Adventurous%20asian%20traveler%20smiling%20portrait%20wearing%20outdoor%20jacket%2C%20soft%20natural%20light%2C%20plain%20warm%20beige%20background%2C%20clean%20modern%20profile%20photo&width=120&height=120&seq=ks-av-06&orientation=squarish",
    publishDate: "2026-09-15",
    views: 2080000,
    duration: "06:20",
    likes: 176500,
    comments: 3410,
    tags: ["海岛", "航拍", "度假"],
    description:
      "用无人机拍下了这片海最美的样子，玻璃海、白沙滩、成群的小鱼，一帧都不想剪掉。住宿和出行攻略放在简介里，想去海岛的朋友可以抄作业。",
  },
  {
    id: "v16",
    title: "冬天就该吃一顿热腾腾的麻辣火锅",
    cover:
      "https://readdy.ai/api/search-image?query=Bubbling%20spicy%20hotpot%20with%20fresh%20vegetables%20and%20meat%20slices%20on%20a%20warm%20wooden%20table%2C%20steam%20rising%2C%20rich%20red%20broth%2C%20appetizing%20close%20up%20with%20cozy%20restaurant%20background&width=640&height=360&seq=ks-cover-16&orientation=landscape",
    categoryId: "food",
    categoryName: "美食",
    authorId: "a2",
    author: "味觉实验室",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Cheerful%20asian%20male%20chef%20smiling%20portrait%20wearing%20white%20apron%2C%20soft%20studio%20light%2C%20plain%20warm%20neutral%20background%2C%20friendly%20cooking%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-02&orientation=squarish",
    publishDate: "2026-10-07",
    views: 1120000,
    duration: "07:12",
    likes: 88600,
    comments: 2050,
    tags: ["火锅", "麻辣", "冬日"],
    description:
      "自己在家也能涮出火锅店的味道。牛油锅底的比例、毛肚怎么涮才脆、蘸料怎么调，都在这期里。天冷了，快叫上朋友一起开涮。",
  },
  {
    id: "v17",
    title: "十分钟晨间瑜伽，唤醒身体",
    cover:
      "https://readdy.ai/api/search-image?query=Fit%20person%20doing%20yoga%20on%20a%20mat%20in%20a%20bright%20minimalist%20room%2C%20morning%20sunlight%20through%20large%20windows%2C%20calm%20wellness%20mood%20with%20soft%20neutral%20tones%20and%20clean%20peaceful%20composition&width=640&height=360&seq=ks-cover-17&orientation=landscape",
    categoryId: "life",
    categoryName: "生活",
    authorId: "a1",
    author: "阿May的生活",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Friendly%20young%20asian%20woman%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20pastel%20background%2C%20casual%20modern%20style%2C%20clean%20high%20detail%20profile%20photo&width=120&height=120&seq=ks-av-01&orientation=squarish",
    publishDate: "2026-09-26",
    views: 692000,
    duration: "10:04",
    likes: 54700,
    comments: 1230,
    tags: ["瑜伽", "拉伸", "健康"],
    description:
      "一套适合零基础的晨间瑜伽，动作舒缓不费力，跟着做完身体会明显轻松很多。建议起床后先喝一杯温水再开始，坚持一周就能感受到变化。",
  },
  {
    id: "v18",
    title: "室友的沙雕舞蹈日常",
    cover:
      "https://readdy.ai/api/search-image?query=Cheerful%20young%20man%20doing%20a%20silly%20dance%20move%20in%20a%20colorful%20bedroom%2C%20playful%20funny%20mood%2C%20bright%20pop%20colors%2C%20casual%20energetic%20vibe%20with%20clean%20simple%20background&width=640&height=360&seq=ks-cover-18&orientation=landscape",
    categoryId: "funny",
    categoryName: "搞笑",
    authorId: "a9",
    author: "萌宠放映厅",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Young%20asian%20person%20holding%20a%20fluffy%20cat%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20cream%20background%2C%20cute%20clean%20profile%20photo&width=120&height=120&seq=ks-av-09&orientation=squarish",
    publishDate: "2026-10-10",
    views: 1560000,
    duration: "02:20",
    likes: 129800,
    comments: 3050,
    tags: ["搞笑", "沙雕", "室友"],
    description:
      "室友说他会跳舞，于是我录了下来。结果这段魔性舞步直接承包了我一周的笑点，已经做成表情包了。你们身边有同款室友吗？",
  },
  {
    id: "v19",
    title: "高效学英语的五个小技巧",
    cover:
      "https://readdy.ai/api/search-image?query=Open%20English%20textbook%20with%20colorful%20sticky%20notes%20and%20a%20cup%20of%20tea%20on%20a%20wooden%20desk%2C%20warm%20cozy%20study%20light%2C%20neat%20organized%20background%2C%20calm%20learning%20atmosphere&width=640&height=360&seq=ks-cover-19&orientation=landscape",
    categoryId: "education",
    categoryName: "教育",
    authorId: "a10",
    author: "学霸计划本",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Focused%20asian%20student%20smiling%20portrait%20holding%20a%20notebook%2C%20soft%20natural%20light%2C%20plain%20calm%20neutral%20background%2C%20clean%20studious%20profile%20photo&width=120&height=120&seq=ks-av-10&orientation=squarish",
    publishDate: "2026-10-11",
    views: 468000,
    duration: "06:02",
    likes: 39600,
    comments: 1080,
    tags: ["英语", "学习", "方法"],
    description:
      "背单词总是记不住？那是方法不对。这期分享了五个我亲测有效的英语学习技巧，包括碎片时间利用、影子跟读和复述训练，附赠一份学习计划模板。",
  },
  {
    id: "v20",
    title: "老电影院的午夜场，氛围感拉满",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20cinema%20seats%20with%20warm%20glowing%20screen%20light%2C%20dramatic%20atmosphere%2C%20deep%20red%20upholstery%2C%20cinematic%20entertainment%20mood%20with%20soft%20focus%20background&width=640&height=360&seq=ks-cover-20&orientation=landscape",
    categoryId: "entertainment",
    categoryName: "娱乐",
    authorId: "a8",
    author: "深夜食堂日记",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20asian%20woman%20food%20blogger%20smiling%20portrait%2C%20soft%20evening%20light%2C%20plain%20warm%20amber%20background%2C%20cozy%20clean%20profile%20photo&width=120&height=120&seq=ks-av-08&orientation=squarish",
    publishDate: "2026-09-12",
    views: 512000,
    duration: "05:28",
    likes: 43800,
    comments: 990,
    tags: ["电影", "氛围", "探店"],
    description:
      "找到一家还在放老电影的小影院，午夜场几乎没有别人，只有银幕的光和爆米花的声音。记录下这个安静的夜晚，也聊聊那些值得重看的老片子。",
  },
  {
    id: "v21",
    title: "橘猫赖床实录，一整个不想上班",
    cover:
      "https://readdy.ai/api/search-image?query=Lazy%20orange%20tabby%20cat%20curled%20up%20in%20a%20sunny%20bed%20refusing%20to%20get%20up%2C%20cozy%20warm%20bedroom%20background%2C%20soft%20morning%20light%2C%20cute%20funny%20pet%20photography&width=640&height=360&seq=ks-cover-21&orientation=landscape",
    categoryId: "life",
    categoryName: "生活",
    authorId: "a9",
    author: "萌宠放映厅",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Young%20asian%20person%20holding%20a%20fluffy%20cat%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20cream%20background%2C%20cute%20clean%20profile%20photo&width=120&height=120&seq=ks-av-09&orientation=squarish",
    publishDate: "2026-10-12",
    views: 834000,
    duration: "03:10",
    likes: 71800,
    comments: 1620,
    tags: ["萌宠", "橘猫", "日常"],
    description:
      "闹钟响了三遍，它就是不肯起来，翻个身继续睡，那副理直气壮的样子简直和周一早上的我一模一样。看完你是不是也不想上班了？",
  },
  {
    id: "v22",
    title: "深夜的一碗泡面，也能很讲究",
    cover:
      "https://readdy.ai/api/search-image?query=A%20steaming%20bowl%20of%20upgraded%20instant%20noodles%20with%20egg%20and%20greens%20on%20a%20cozy%20night%20table%2C%20warm%20lamp%20light%2C%20appetizing%20close%20up%20with%20soft%20blurred%20background&width=640&height=360&seq=ks-cover-22&orientation=landscape",
    categoryId: "food",
    categoryName: "美食",
    authorId: "a8",
    author: "深夜食堂日记",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20asian%20woman%20food%20blogger%20smiling%20portrait%2C%20soft%20evening%20light%2C%20plain%20warm%20amber%20background%2C%20cozy%20clean%20profile%20photo&width=120&height=120&seq=ks-av-08&orientation=squarish",
    publishDate: "2026-09-29",
    views: 456000,
    duration: "04:14",
    likes: 37200,
    comments: 810,
    tags: ["夜宵", "泡面", "简单"],
    description:
      "加班回家不想做饭，一碗泡面也能吃得有仪式感。加个蛋、放把青菜、再来点芝士，三分钟升级成功。给每个深夜奋斗的人一点小小的慰藉。",
  },
  {
    id: "v23",
    title: "古镇慢生活，一条街逛一下午",
    cover:
      "https://readdy.ai/api/search-image?query=Charming%20ancient%20town%20street%20with%20stone%20lanes%20and%20wooden%20shops%20in%20soft%20afternoon%20light%2C%20peaceful%20slow%20travel%20mood%2C%20warm%20nostalgic%20town%20tones%20with%20clean%20composition&width=640&height=360&seq=ks-cover-23&orientation=landscape",
    categoryId: "travel",
    categoryName: "旅行",
    authorId: "a6",
    author: "山海旅行记",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Adventurous%20asian%20traveler%20smiling%20portrait%20wearing%20outdoor%20jacket%2C%20soft%20natural%20light%2C%20plain%20warm%20beige%20background%2C%20clean%20modern%20profile%20photo&width=120&height=120&seq=ks-av-06&orientation=squarish",
    publishDate: "2026-09-16",
    views: 738000,
    duration: "06:48",
    likes: 61200,
    comments: 1340,
    tags: ["古镇", "慢生活", "散步"],
    description:
      "没有攻略，没有打卡清单，就是慢悠悠地逛一条老街。喝了碗甜酒，听了评弹，看了落日，一天就这样过去了。有时候旅行不需要目的，放空就好。",
  },
  {
    id: "v24",
    title: "街舞配乐即兴创作现场",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20producer%20improvising%20a%20beat%20on%20a%20drum%20machine%20and%20keyboard%20in%20a%20warm%20studio%2C%20colorful%20LED%20accent%20light%2C%20creative%20energetic%20mood%20with%20clean%20modern%20background&width=640&height=360&seq=ks-cover-24&orientation=landscape",
    categoryId: "music",
    categoryName: "音乐",
    authorId: "a4",
    author: "舞动青春",
    authorAvatar:
      "https://readdy.ai/api/search-image?query=Confident%20young%20asian%20female%20dancer%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20pastel%20background%2C%20energetic%20modern%20profile%20photo%20with%20clean%20detail&width=120&height=120&seq=ks-av-04&orientation=squarish",
    publishDate: "2026-10-13",
    views: 298000,
    duration: "05:36",
    likes: 26400,
    comments: 640,
    tags: ["音乐制作", "街舞", "即兴"],
    description:
      "和舞伴一起即兴玩了一段，她跳我配乐，全程一次过没有彩排。这种音乐和舞蹈互相回应的感觉太爽了，最后那段卡点我自己都起鸡皮疙瘩。",
  },
];

export const creatorProfile = {
  name: "阿May的生活",
  avatar:
    "https://readdy.ai/api/search-image?query=Friendly%20young%20asian%20woman%20smiling%20warm%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20pastel%20background%2C%20casual%20modern%20lifestyle%20creator%20style%2C%20clean%20high%20detail&width=160&height=160&seq=ks-creator-01&orientation=squarish",
  bio: "生活记录者 | 短视频创作 3 年 | 分享拍摄技巧与日常灵感，愿每个人都能被生活温柔以待。",
  followers: 128400,
  totalViews: 4560000,
  totalLikes: 386000,
  videoCount: 86,
};

export const creatorVideoIds = ["v2", "v11", "v17"];

export const siteIntro = {
  title: "关于快手",
  subtitle: "记录每一种生活，发现每一份热爱",
  paragraphs: [
    "快手是一个综合短视频平台，聚焦热门短视频内容与创作社区。无论你是喜欢刷视频的观众，还是热爱拍摄的内容创作者，都能在这里找到属于自己的舞台。",
    "平台内容覆盖生活、美食、娱乐、搞笑、教育、舞蹈、音乐、旅行等多个领域，通过推荐算法帮助用户快速发现感兴趣的内容，也让优质作品被更多人看到。",
    "我们鼓励真实、温暖、有创意的表达，支持每一位创作者的成长，让记录生活这件事变得更简单、更有意义。",
  ],
};